import { IDmTrangThaiHocActionTypes } from "../../action-types/category/IDmTrangThaiHocActions";
import { IDmTrangThaiHocReducer } from "../../reducer-model/category/IDmTrangThaiHocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDmTrangThaiHocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  trangThaiHocs: [],
};
export const trangThaiHocReducer = (
  state: IDmTrangThaiHocReducer = iniState,
  action: IDmTrangThaiHocActionTypes
): IDmTrangThaiHocReducer => {
  switch (action.type) {
    case "TRANG_THAI_HOC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "TRANG_THAI_HOC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        trangThaiHocs: action.payload,
      };
    case "TRANG_THAI_HOC_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
